import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

import Item from './item';

lessRequire('modules/shared/filters/items.less');

const propTypes = {
	filters: PropTypes.object,
	filterToggleChildrenHighlight: PropTypes.func,
	filterToggle: PropTypes.func,
	intl: PropTypes.func
};

class Items extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			itemsTranslate: 0,
			shouldActivateSlideControl: false
		};
	}

	componentDidMount() {
		const containerWidth = this._container.offsetWidth;
		const itemsScrollWidth = this._items.scrollWidth;
		const shouldActivateSlideControl = (itemsScrollWidth - containerWidth) > 0;

		this.setState({
			shouldActivateSlideControl
		});
	}

	calculateTranslateOffset() {
		const containerWidth = this._container.offsetWidth;
		const controlWidth = this._control.offsetWidth;
		const itemsScrollWidth = this._items.scrollWidth;
		return (itemsScrollWidth - containerWidth) +  controlWidth;
	}

	onNext() {
		if (this.state.itemsTranslate === 0) {
			this.setState({
				itemsTranslate: -(this.calculateTranslateOffset())
			});
		}
	}

	onPrev() {
		if (this.state.itemsTranslate !== 0) {
			this.setState({
				itemsTranslate: 0
			});
		}
	}

	getTranslateStyle() {
		const translate = `translate(${this.state.itemsTranslate}px, 0)`;

		return {
			WebkitTransform: translate,
			MozTransform: translate,
			msTransform: translate,
			OTransform: translate,
			transform: translate
		};
	}

	render() {
		const translate = this.getTranslateStyle();
		return (
			<div
				ref={el => this._container = el}
				className={cn('filters-wrap-items-container', this.state.itemsTranslate !== 0 && 'show-container-gradient')}>
				<div ref={el => this._items = el} className="filters-wrap__items" style={translate}>
					{ this.props.filters.list.map((filter, i) =>
						<Item
							data={filter}
							toggleChildrenHighlight={this.props.filterToggleChildrenHighlight}
							onToggle={this.props.filterToggle}
							key={i}
							intl={this.props.intl}
						/>
					) }
				</div>

				{ this.state.shouldActivateSlideControl && (
					<div
						ref={el => this._control = el}
						className={cn(
							'filters-wrap-items-container__controls',
							this.state.itemsTranslate === 0 && 'show-control-gradient'
						)}>
						<span
							onClick={this.onNext.bind(this)}
							className={cn('control control--next', this.state.itemsTranslate === 0 && 'control--active')} />
						<span
							onClick={this.onPrev.bind(this)}
							className={cn('control control--prev', this.state.itemsTranslate !== 0 && 'control--active')} />
					</div>
				) }
			</div>
		);
	}
}

Items.propTypes = propTypes;
export default Items;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/items.js